module.exports = __webpack_public_path__ + "img/brand.a76ebdf8.png";